import createLucideIcon from '../createLucideIcon';

/**
 * @component @name HousePlus
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuNjYyIDIxSDVhMiAyIDAgMCAxLTItMnYtOWEyIDIgMCAwIDEgLjcwOS0xLjUyOGw3LTUuOTk5YTIgMiAwIDAgMSAyLjU4MiAwbDcgNS45OTlBMiAyIDAgMCAxIDIxIDEwdjIuNDc1IiAvPgogIDxwYXRoIGQ9Ik0xNC45NTkgMTIuNzE3QTEgMSAwIDAgMCAxNCAxMmgtNGExIDEgMCAwIDAtMSAxdjgiIC8+CiAgPHBhdGggZD0iTTE1IDE4aDYiIC8+CiAgPHBhdGggZD0iTTE4IDE1djYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/house-plus
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const HousePlus = createLucideIcon('house-plus', [
  [
    'path',
    {
      d: 'M12.662 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v2.475',
      key: 'uubd2h',
    },
  ],
  ['path', { d: 'M14.959 12.717A1 1 0 0 0 14 12h-4a1 1 0 0 0-1 1v8', key: 'p7f341' }],
  ['path', { d: 'M15 18h6', key: '3b3c90' }],
  ['path', { d: 'M18 15v6', key: '9wciyi' }],
]);

export default HousePlus;
